import { Download, Message } from '@showbie/utilities/message';

import { sendMessageWithMessageOnly } from './sendMessageHelper';

export function sendDownloadInitiateMessage(url: string) {
  const downloadInitiateMessage: Message = {
    type: Download.Initiate,
    payload: { url },
  };
  sendMessageWithMessageOnly(downloadInitiateMessage);
}
